<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  width: {
    type: Number,
    default: undefined,
  },
  height: {
    type: Number,
    default: undefined,
  },
})

const iframeStyles = computed<string>(() => {
  if (props.width && props.height) {
    return `max-width: ${props.width}px; aspect-ratio: ${
      props.width / props.height
    };`
  }

  if (props.width) {
    return `max-width: ${props.width}px; aspect-ratio: 16/9`
  }

  return 'aspect-ratio: 16/9'
})
</script>

<template>
  <iframe class="ProseIframe" :style="iframeStyles" />
</template>

<style lang="scss">
.ProseIframe {
  width: 100%;
  border: none;
}
</style>
